// 文件类型
export function fileType(url = '', _type = '') {
	url = url.toLowerCase();
	_type = _type.toLowerCase();
    // url文件链接，type如果传了就判断相不相等，否则返回文件类型
    let __type = '';
    let suffix = '';
    try {
    	let temp = url.split('.');
    	suffix = temp[temp.length - 1];
    } catch (err) {
    	suffix = '';
    }
    const typeConfig = {
    	'txt': [ 'txt' ],
    	'pdf': [ 'pdf' ],
    	'ppt': [ 'ppt', 'pptx' ],
    	'word': [ 'doc', 'docx' ],
    	'excel': [ 'xls', 'xlsx' ],
    	'image': [ 'png', 'jpg', 'jpeg', 'bmp', 'gif' ],
    	'audio': [ 'wav', 'mp3', 'm4a', 'ogg', 'acc', 'webm' ],
    	'video': [
    			'avi', 'flv', 'mpg', 'mpeg', 'mpe', 'm1v', 'm2v',
    			'mpv2', 'mp2v', 'dat', 'ts', 'tp', 'tpr', 'pva',
    			'pss', 'mp4', 'm4v', 'm4p', 'm4b', '3gp', '3gpp',
    			'3g2', '3gp2', 'mov', 'qt', 'amr', 'rm',
    			'ram', 'rmvb', 'rpm', 'mkv', 'wmv'
    		],
    };
    for (let [type, list] of Object.entries(typeConfig)) {
    	let result = list.find(v => v === suffix);
    	if (result) {
    		__type = type;
    		break;
    	}
    }
    if (_type) {
    	return __type === _type;
    }
    return __type || suffix;
}


// 文件信息(异步函数)
export function fileInfo(src = '', type = '') {
    return new Promise(resolve => {
        const data = Object.create(null);
        data['status'] = 'error';
        data['type'] = type;
        data['url'] = src;
        let element = null;
        // 如果是图片
        if (type === 'image') {
            element = new Image();
            element.addEventListener('load', function() {
                data['height'] = Math.round(this.height * 100) / 100;
                data['width'] = Math.round(this.width * 100) / 100;
                data['status'] = 'success';
                element = null;
                resolve(data);
            });
            element.addEventListener('error', function() {
            	data['height'] = 0;
            	data['width'] = 0;
            	element = null;
            	resolve(data);
            });
            element.src = src;
            // element.load(); // 图片对象没有load事件
        }
        // 如果是音频
        else if (data['type'] === 'audio') {
            element = new Audio();
            element.addEventListener('loadedmetadata', function() {
            	// 安卓手机端的时长为0，使用定时器延迟获取仍然为0，且链接错误时不会触发error事件
            	data['duration'] = Math.round(element.duration * 100) / 100;
            	data['status'] = 'success';
            	element = null;
            	resolve(data);
            });
            element.addEventListener('error', function() {
            	data['duration'] = 0;
            	element = null;
            	resolve(data);
            });
            element.src = src;
            element.load();
        }
        // 如果是视频
        else if (data['type'] === 'video') {
            element = document.createElement('video');
            element.addEventListener('loadedmetadata', function() {
            	// 安卓手机端的时长为0，使用定时器延迟获取仍然为0，且链接错误时不会触发error事件
            	data['duration'] = Math.round(element.duration * 100) / 100;
            	data['status'] = 'success';
            	element = null;
            	resolve(data);
            });
            element.addEventListener('error', function() {
            	data['duration'] = 0;
            	element = null;
            	resolve(data);
            });
            element.src = src;
            element.load();
        }
        // 其它文件
        else {
            resolve(data);
        }
    });
}